// =============================================================
// librarySearch.js — how the company library search decides a record matches.
//
// Every word must be found somewhere in the record: in what is on screen (its
// fields, its company, its file names, the AI's summaries — matched here) OR
// inside the full text of one of its files (matched by the server,
// GET /api/govbid/library-search, migration 245). A record can match one word
// in its title and another on page 40 of its RFP.
// =============================================================

// Words as the user typed them, lower-cased. The server drops words under two
// characters; those still match on screen.
export function searchWords(q) {
  return String(q || '').toLowerCase().split(/\s+/).filter(Boolean);
}

const key = (id) => String(id || '').toLowerCase();

// The server's answer → Map(term → Map(itemId → first hit)).
export function fileTextIndex(result) {
  const index = new Map();
  for (const t of (result && result.terms) || []) {
    const byItem = new Map();
    for (const h of t.hits || []) if (!byItem.has(key(h.itemId))) byItem.set(key(h.itemId), h);
    index.set(String(t.term).toLowerCase(), byItem);
  }
  return index;
}

export function recordMatches(haystack, itemId, words, index) {
  return words.every(w => haystack.includes(w) || !!index?.get(w)?.has(key(itemId)));
}

// The words found ONLY inside a file's text, each with that file and an
// excerpt — what the row shows so the reader can see why it matched.
export function fileTextReasons(haystack, itemId, words, index) {
  const out = [];
  for (const w of words) {
    if (haystack.includes(w)) continue;
    const hit = index?.get(w)?.get(key(itemId));
    if (hit) out.push({ word: w, fileName: hit.fileName, snippet: hit.snippet });
  }
  return out;
}
